import { getNewbuildingMVK } from '../../api/newbuilding_mvk';
import { IThunkActionCreator } from '..';
import {
  TResponses,
  IGetNewbuildingPolygonsResponse,
} from '../../repositories/newbuilding-mvk/v2/get-newbuilding-polygons';
import { IGetNewBuildingPolygonsResponseSchema } from '@cian/api-models/newbuilding-mvk/v2/get-newbuilding-polygons';

interface ISetNewbuildingMvkDataAction {
  MVKData: IGetNewbuildingPolygonsResponse;
  type: 'ISetNewbuildingMvkDataAction';
}

interface ISetNewbuildingMvkIsWidgetOpenAction {
  isOpen: boolean;
  sectionId?: number;
  type: 'ISetNewbuildingMvkIsWidgetOpenAction';
}

interface ISetFloorPlanImageUrlAction {
  url: string;
  type: 'ISetFloorPlanImageUrlAction';
}

export interface INewbuildingMvkState {
  MVKData?: IGetNewbuildingPolygonsResponse;
  openedSectionId?: number;
  offerFloorPlanImage?: string;
  isWidgetOpen: boolean;
}

export function setFloorPlanImageUrlAction(url: string): ISetFloorPlanImageUrlAction {
  return {
    url,
    type: 'ISetFloorPlanImageUrlAction',
  };
}

export function setNewbuildingMvkDataAction(MVKData: IGetNewbuildingPolygonsResponse): ISetNewbuildingMvkDataAction {
  return {
    MVKData,
    type: 'ISetNewbuildingMvkDataAction',
  };
}

export function setNewbuildingMvkIsWidgetOpenAction(
  isOpen: boolean,
  sectionId?: number,
): ISetNewbuildingMvkIsWidgetOpenAction {
  return {
    isOpen,
    sectionId,
    type: 'ISetNewbuildingMvkIsWidgetOpenAction',
  };
}

interface IMVKWidget {
  getFloorPlanImageUrlByOfferId(mvkData: IGetNewBuildingPolygonsResponseSchema, offerId: number): Promise<string>;
  MVKIsValid(MVKData: IGetNewBuildingPolygonsResponseSchema): boolean;
  offerIsConnectedWithFloorPlan(MVKData: IGetNewBuildingPolygonsResponseSchema, offerId: number): boolean;
}

export function fetchNewbuildingMvk(newbuildingId: number): IThunkActionCreator {
  return async (dispatch, getState, context) => {
    try {
      const [MVKData, { getFloorPlanImageUrlByOfferId, MVKIsValid, offerIsConnectedWithFloorPlan }] = await Promise.all<
        TResponses,
        IMVKWidget
      >([getNewbuildingMVK(context.httpApi, { newbuildingId }), import('@cian/mvk-widget')]);

      const offerId = getState().offerData.offer.id;

      /** Надо убирать api-models из mvk-widget CD-49347**/
      //tslint:disable-next-line:no-any
      if (MVKIsValid(MVKData as any) && offerIsConnectedWithFloorPlan(MVKData as any, offerId)) {
        /** Надо убирать api-models из mvk-widget CD-49347**/
        //tslint:disable-next-line:no-any
        dispatch(setNewbuildingMvkDataAction(MVKData as any));

        /** Надо убирать api-models из mvk-widget CD-49347**/
        //tslint:disable-next-line:no-any
        await getFloorPlanImageUrlByOfferId(MVKData as any, offerId)
          .then((url: string) => dispatch(setFloorPlanImageUrlAction(url)))
          .catch(e => {
            context.logger.warning('[Degradation] Failed to getFloorPlanImageUrlByOfferId', e);
          });
      }
    } catch (e) {
      context.logger.warning('[Degradation] Unexpected error on fetchNewbuildingMvk', e);
    }
  };
}

const defaultState: INewbuildingMvkState = {
  isWidgetOpen: false,
};

type Action = ISetNewbuildingMvkDataAction | ISetNewbuildingMvkIsWidgetOpenAction | ISetFloorPlanImageUrlAction;

export function newbuildingMvkReducer(state: INewbuildingMvkState, action: Action): INewbuildingMvkState {
  switch (action.type) {
    case 'ISetNewbuildingMvkDataAction':
      return {
        ...state,
        MVKData: action.MVKData,
      };
    case 'ISetNewbuildingMvkIsWidgetOpenAction':
      return {
        ...state,
        openedSectionId: action.sectionId,
        isWidgetOpen: action.isOpen,
      };
    case 'ISetFloorPlanImageUrlAction':
      return {
        ...state,
        offerFloorPlanImage: action.url,
      };
    default:
      return state || defaultState;
  }
}
